import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Abas Tokens ↔ Webhooks — sticky para não “sumirem” ao rolar o histórico longo.
 */
const IntegrationSettingsTabs = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const onTokens = pathname.startsWith("/settings/api-tokens");
  const onWebhooks = pathname.startsWith("/settings/webhooks");

  return (
    <div
      className="mb-3"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1020,
        background: "var(--vz-body-bg, #fff)",
        paddingTop: "0.25rem",
      }}
    >
      <Nav tabs className="mb-0">
        <NavItem>
          <NavLink
            tag={Link}
            to="/settings/api-tokens"
            active={onTokens}
            className={onTokens ? "active" : undefined}
          >
            {t("settings.integrationTabs.tokens")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            tag={Link}
            to="/settings/webhooks"
            active={onWebhooks}
            className={onWebhooks ? "active" : undefined}
          >
            {t("settings.integrationTabs.webhooks")}
          </NavLink>
        </NavItem>
      </Nav>
    </div>
  );
};

export default IntegrationSettingsTabs;
